import { render, staticRenderFns } from "./ObservationPage.vue?vue&type=template&id=1bb91bee&"
import script from "./ObservationPage.vue?vue&type=script&lang=js&"
export * from "./ObservationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports